import React, { FC, PropsWithChildren } from 'react';
import { PortalPlaceholder, PortalRenderer } from '@/components/Portal';

const PORTAL_ID: string = 'left-sidebar-portal-placeholder';

export const LeftSidebarPortalPlaceholder: FC = () => (
  <PortalPlaceholder id={PORTAL_ID}></PortalPlaceholder>
);

interface ILeftSidebarPortalProps {}

export const LeftSidebarPortal: FC<
  PropsWithChildren<ILeftSidebarPortalProps>
> = ({ children }) => (
  <PortalRenderer id={PORTAL_ID}>{children}</PortalRenderer>
);
